import SectionHeading from "../../../../../../../shared/components/ui/SectionHeading/SectionHeading";

export default function ContactHeading({ content, EyebrowIcon }) {
  return (
    <div className="reveal-on-scroll reveal-on-scroll--up">
      <SectionHeading
        eyebrow="Contato"
        title={
          <>
            {content.titleMain} <br />
            <span>{content.titleAccent}</span>
          </>
        }
        description={content.description}
        icon={EyebrowIcon}
        className="contact-section__heading"
      />
    </div>
  );
}